import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M5.349 3.132a.743.743 0 0 1-.75.75H2.9a.75.75 0 0 1 0-1.5h1.7a.749.749 0 0 1 .749.75ZM4.6 5.592H2.9a.75.75 0 0 0 0 1.5h1.7a.75.75 0 0 0 0-1.5Zm8.97 3.23h-3.3a.75.75 0 0 0 0 1.5h3.3a.75.75 0 0 0 0-1.5Zm-8.97 3.22H2.9a.75.75 0 1 0 0 1.5h1.7a.75.75 0 0 0 0-1.5Zm7.86 0h-2.43a.75.75 0 0 0 0 1.5h2.43a.75.75 0 0 0 0-1.5Zm.75-5.7a.755.755 0 0 0-.75-.75H7.749v-1.71h1.66a.75.75 0 0 0 0-1.5h-1.66v-.43a.75.75 0 0 0-1.5 0v12.04a.75.75 0 0 0 1.5 0v-6.9h4.71a.755.755 0 0 0 .75-.75ZM4.6 8.822H2.9a.75.75 0 0 0 0 1.5h1.7a.75.75 0 0 0 0-1.5Z';
const draw24px =
  'M19.69,9.25a.76.76,0,0,1-.75.75h-9V22a.75.75,0,0,1-1.5,0V1.94a.75.75,0,1,1,1.5,0V3.16h3.55a.74.74,0,0,1,.75.74.75.75,0,0,1-.75.76H9.92V8.5h9A.75.75,0,0,1,19.69,9.25Zm2,5.37a.75.75,0,0,0-.75-.75H15a.75.75,0,0,0,0,1.5h5.91A.74.74,0,0,0,21.69,14.62Zm-2,5.38a.76.76,0,0,0-.75-.75H14.59a.75.75,0,0,0,0,1.5h4.35A.76.76,0,0,0,19.69,20ZM4,5.3A1.25,1.25,0,1,0,2.75,4.05,1.25,1.25,0,0,0,4,5.3Zm0,5.2A1.25,1.25,0,1,0,2.75,9.25,1.25,1.25,0,0,0,4,10.5Zm0,5.37a1.25,1.25,0,1,0-1.25-1.25A1.25,1.25,0,0,0,4,15.87Zm0,5.38A1.25,1.25,0,1,0,2.75,20,1.25,1.25,0,0,0,4,21.25Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ChartGanttListIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'chartGanttList')) as IconWithRender;

ChartGanttListIcon.displayName = 'ChartGanttListIcon';
ChartGanttListIcon.propTypes = Icon.propTypes;
ChartGanttListIcon.renderIcon = (props) => <ChartGanttListIcon {...props} />;
export default ChartGanttListIcon;
